import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/audit/')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/audit/stream' });
  },
});
